import { devtoolActionsContext } from "components/Layout/utils";
import { useEditor } from "features/editor/Feature";
import type { DocsTab } from "features/types/tabs";
import { Box } from "prism-react";
import { useContext, useEffect, useRef } from "react";

import { DevtoolWrapper } from "./common/DevtoolWrapper";
import type { TabPanelProps } from "./types";

export const DocsDevtool: React.FC<TabPanelProps<DocsTab>> = ({
  tab,
  isActiveTab,
}) => {
  const project = useEditor();
  const baseUrl = `https://codesandbox.io/docs/learn`;
  const fallbackPath =
    project.type === "branch"
      ? "/repositories/overview"
      : project.isCloud
        ? "/vm-sandboxes/overview"
        : "/editors/overview";
  const docsUrl = `${baseUrl}${tab.path || fallbackPath}`;
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const shellActions = useContext(devtoolActionsContext);

  useEffect(() => {
    if (!isActiveTab) return;

    return shellActions.addItem({
      id: "documentation",
      href: docsUrl,
      tooltip: "Open documentation",
      icon: "externalLink",
    });
  }, [isActiveTab]);

  return (
    <DevtoolWrapper variant="file">
      <Box
        css={{
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <iframe
          ref={iframeRef}
          src={docsUrl}
          style={{
            border: 0,
            width: "100%",
            height: "100%",
          }}
          title="docs"
        />
      </Box>
    </DevtoolWrapper>
  );
};
